import { EstimateWithComponentsDto } from "../../../shared/dtos/estimate-with-components.dto";

export interface WorkOrderDto {
  id: number;
  companyId: number;
  estimateId: number;
  notes?: string;
  status: WorkOrderStatusType;
  estimateData: EstimateWithComponentsDto;
  /** "YYYY-MM-DD" (SQ-393). */
  scheduledDate?: string | null;
  /** "HH:MM", 24-hour (SQ-393). */
  scheduledStartTime?: string | null;
  createdAt: string;
  createdBy: number;
  updatedAt: string;

  clientId: number;
  clientName: string;
  clientAddress: string;
  clientCity: string;
  clientState: string;
  clientPostalCode: string;
  clientEmail?: string;
  clientPhoneNumber?: string;
}

export interface WorkOrderUpdateDto {
  notes?: string;  
}

export interface WorkOrderUpdateStatusDto {
  status: WorkOrderStatusType;
}

export const WorkOrderStatus = {
  Confirmed: 'Confirmed',
  Scheduled: 'Scheduled',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Invoiced: 'Invoiced',
  PendingReInvoice: 'PendingReInvoice',
  OnHold: 'OnHold',
  Cancelled: 'Cancelled',
  Deleted: 'Deleted'
} as const;

export type WorkOrderStatusType = typeof WorkOrderStatus[keyof typeof WorkOrderStatus];